import React, { Component } from "react";
import * as R from "ramda";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import { PDFReader } from "reactjs-pdf-reader";

class DetailPenagihanLeasingPrintPreview extends Component {
    render() {
        const { data, visible, onClose, onStateChange, title } = this.props;

        return (
            <SimpleModal
                title={title}
                visible={visible}
                onClickClose={()=>onClose(false)}
                styles={{ width: "100%" }}
                content={
                    <>
                        {data && (
                            <div style={{ width: "100%", height: "100vh", overflow: "auto" }}>
                                <PDFReader
                                    url={data}
                                />
                            </div>
                        )}
                        <input
                            type="file"
                            accept=".pdf"
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (file && file.type === "application/pdf") {
                                    const fileReader = new FileReader();
                                    fileReader.onload = () => {
                                        onStateChange({
                                            PDF: fileReader.result,
                                        });
                                    };
                                    
                                    fileReader.readAsDataURL(file);
                                }
                            }}
                        />
                    </>
                }
            />
        );
    }
}

export default DetailPenagihanLeasingPrintPreview;
